import React from "react";
import CommonHeader from "./CommonHeader"; // ή η σωστή διαδρομή σου
import { useDarkMode } from "context/DarkModeProvider";

const GeneralStageLayout = ({ children }) => {
    const { darkMode } = useDarkMode();
    return (

        <div style={{ background: darkMode ? "#0f172a" : "var(--lightModeBack)", }}>

            <CommonHeader />
            <main className="flex-1 p-4" style={{}}>
                {children}
            </main>
        </div >
    );
};

export default GeneralStageLayout;
